import _ = require('underscore');

const INDICATOR_MAXIMUM_MESSAGE_LENGTH: number = 4000;

export type IllegalDataQualityIndicator = 'TOOLONG' | 'NOMESSAGE';

export type DataQualityIndicatorCommand = IllegalDataQualityIndicator | 'SUBMIT' | 'DELETE';

export function canSubmitDataQualityIndicator(params: { message: string, active: boolean }): DataQualityIndicatorCommand {
  const { message, active } = params;

  if (message.length > INDICATOR_MAXIMUM_MESSAGE_LENGTH) {
    return 'TOOLONG';
  }

  if (_.isEmpty(message.trim())) {
    if (active) {
      return 'NOMESSAGE';
    } else {
      return 'DELETE';
    }
  }

  return 'SUBMIT';
}
